import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import Hero from "@/components/site/Hero";
import HeroBanner from "@/components/site/HeroBanner";
import Stats from "@/components/site/Stats";
import About from "@/components/site/About";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import Courses from "@/components/site/Courses";
import StudyAbroad from "@/components/site/StudyAbroad";
import Universities from "@/components/site/Universities";
import LearningProcess from "@/components/site/LearningProcess";
import Projects from "@/components/site/Projects";
import CareerPaths from "@/components/site/CareerPaths";
import Partners from "@/components/site/Partners";
import Testimonials from "@/components/site/Testimonials";
import Blog from "@/components/site/Blog";
import FAQ from "@/components/site/FAQ";
import Contact from "@/components/site/Contact";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";
import EnquiryPopup from "@/components/site/EnquiryPopup";
import { EnquiryPopupProvider } from "@/context/EnquiryPopupContext";

export default function Home() {
  return (
    <EnquiryPopupProvider>
      <div className="min-h-screen bg-white text-[#1F2937]" data-testid="home-page">
        <Header />
        <main>
          <Hero />
          <HeroBanner />
          <Stats />
          <About />
          <WhyChooseUs />
          <Courses />
          <StudyAbroad />
          <Universities />
          <LearningProcess />
          <Projects />
          <CareerPaths />
          <Partners />
          <Testimonials />
          <Blog />
          <FAQ />
          <Contact />
        </main>
        <Footer />
        <WhatsAppFloat />
        <EnquiryPopup />
      </div>
    </EnquiryPopupProvider>
  );
}
